import { render, staticRenderFns } from "./ColorGrid.vue?vue&type=template&id=535c73ba"
import script from "./ColorGrid.vue?vue&type=script&lang=ts"
export * from "./ColorGrid.vue?vue&type=script&lang=ts"
import style0 from "./ColorGrid.vue?vue&type=style&index=0&id=535c73ba&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports